import React from "react";
import Modal from "react-modal";
import "../../styles/CustomModal.css";
import styled from "styled-components";

const ConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  title: string;
  cancelText?: string;
  confirmText: string;
  onConfirm?: any;
  icon?: string | undefined;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="confirmModal modal-content"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />
          {oProps.icon && (
            <img className="icon" src={oProps.icon} alt="아이콘" />
          )}
          <p
            className={`titleFont ${!oProps.cancelText && "gap"} 
            ${oProps.icon && "icon"}
            `}
          >
            {oProps.title}
          </p>

          <div className="bottomButtonWrap">
            {oProps.cancelText && (
              <div className="cancelButton" onClick={onCloseModal}>
                {oProps.cancelText}
              </div>
            )}
            <div
              className="confirmButton"
              onClick={oProps.onConfirm ? oProps.onConfirm : onCloseModal}
            >
              {oProps.confirmText}
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ConfirmModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;
    padding: 22px 24px;
  }

  .closeIcon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
  }

  .titleFont {
    padding: 77px 0;
    font-size: 24px;
    line-height: 43px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
  .titleFont.icon {
    padding: 20px 0 51px 0;
  }

  img.icon {
    margin-top: 10px;
    width: 63px;
    height: 63px;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 30px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #555555;
      background: #e5e5e5;
      border: 1px solid #e5e5e5;
    }

    .confirmButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 30px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }

  @media (max-width: 700px) {
    .titleFont {
      font-size: 20px;
      line-height: 30px;
      font-weight: 400;
    }
    .titleFont.icon {
      font-size: 17px;
      line-height: 26px;
      padding: 18px 0 36px 0;
    }
    .closeIcon {
      width: 24px;
      right: 12px;
      top: 12px;
    }
    img.icon {
      width: 48px;
      height: 48px;
    }
    .bottomButtonWrap {
      .confirmButton {
        padding: 12px 0;
        font-size: 20px;
        font-weight: 600;
      }
      .cancelButton {
        padding: 12px 0;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
`;
